import type { Dict } from "@/types/dict";


export type FormEventHookCallback<State extends Dict, Ret> = (state: State) => Ret

export enum EFormEventHookOrder {
  EARLY = 'EARLY',
  LATE = 'LATE'
}

export type FormEventHooks<State extends Dict, Path extends string, Ret = any> = {
  [k in Path]: {
    fun: FormEventHookCallback<State, Ret>;
    order?: EFormEventHookOrder;
  };
}
